import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import { withStyles } from '@material-ui/core/styles';
import MuiDialogTitle from '@material-ui/core/DialogTitle';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import FormControl from '@material-ui/core/FormControl';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import Select from '@material-ui/core/Select';
import Switch from '@material-ui/core/Switch';
import Fab from '@material-ui/core/Fab';
import Layout from './layout'
const useStyles = makeStyles((theme) => ({
  form: {
    display: 'flex',
    flexDirection: 'column',
    margin: 'auto',
    width: 'fit-content',
  },
  formControl: {
    marginTop: theme.spacing(2),
    minWidth: 120,
  },
  formControlLabel: {
    marginTop: theme.spacing(1),
  },
}));

const styles = (theme) => ({
  root: {
    margin: 0,
  padding:0
  },
  closeButton: {
    position: 'absolute',
    right: theme.spacing(1),
    top: theme.spacing(1),
    color: 'white'
  },
});


const DialogTitle = withStyles(styles)((props) => {
  const { children, classes, onClose, ...other } = props;
  return (
    <MuiDialogTitle disableTypography className={classes.root} {...other}>

      {onClose ? (
        <Fab color="secondary" aria-label="close" className={classes.closeButton} onClick={onClose}>
        <CloseIcon />
      </Fab>

      ) : null}
    </MuiDialogTitle>
  );
});

export default function MaxWidthDialog({handleClose,post_fn}) {
 
  const classes = useStyles();

  const [fullWidth, setFullWidth] = React.useState(true);
  const [maxWidth, setMaxWidth] = React.useState('md');


  const handleMaxWidthChange = (event) => {
    setMaxWidth(event.target.value);
  };

  const handleFullWidthChange = (event) => {
    setFullWidth(event.target.checked);
  };

  return (
    <React.Fragment>

     <Dialog
     disableBackdropClick
           disableEscapeKeyDown
        fullWidth={fullWidth}
        maxWidth={maxWidth}
        open
        onClose={handleClose}
        aria-labelledby="max-width-dialog-title"

      >
      <DialogTitle id="customized-dialog-title" onClose={handleClose}>
                Modal title
              </DialogTitle>


         <Layout post_fn={post_fn} handleClose={handleClose}/>



  </Dialog>
    </React.Fragment>
  );
}
